/** Service agreement for web demo (and demo only) */
export const DEMO_SERVICE_AGREEMENT_FILE_URI = '/files/MVision Web Demo Service Agreement.pdf';
